import partnerSettingsApiService from '@/shared/services/partner-settings-api.service'

import { TOAST_DISPATCHERS } from '@/shared/constants/store-constants/toast'

export default {
  resetStore({ commit }) {
    commit('RESET_STORE')
  },

  parsePayload({ commit }, payload) {
    commit('SET_SETTINGS', payload)

    if (
      payload &&
      payload.lower_fee !== undefined &&
      payload.upper_fee !== undefined
    ) {
      commit('SET_FEES', {
        lowerFee: payload.lower_fee,
        upperFee: payload.upper_fee,
      })
    }
  },

  async getPartnerSettings({ commit, dispatch }, coin) {
    try {
      commit('SET_LOADING', true)

      const response = await partnerSettingsApiService.getPartnerSettings({
        convert_to_coin_id: coin,
      })

      dispatch('parsePayload', response)
    } catch (error) {
      if (!error.isHandled) {
        dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
      }
    } finally {
      commit('SET_LOADING', false)
    }
  },
}
